import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from 'app/api';

const constructUrl = (projectId, locationId = '') =>
    `/project/${projectId}/location${locationId ? `/${locationId}` : ''}`;

export const createLocation = createAsyncThunk('location/create', async ({ projectId, location }, { dispatch }) => {
    const { data } = await API.post(constructUrl(projectId), location);
    // Await the refresh so callers that select the new id right away find it
    // in the list instead of briefly holding an out-of-range value.
    await dispatch(getAllLocations({ projectId }));
    return data;
});

export const updateLocation = createAsyncThunk('location/update', async ({ projectId, id, location }, { dispatch }) => {
    const { data } = await API.put(constructUrl(projectId, id), location);
    dispatch(getAllLocations({ projectId }));
    return data;
});

export const getAllLocations = createAsyncThunk('location/getAll', async ({ projectId }) => {
    const { data } = await API.get(constructUrl(projectId));
    return data;
});

export const getLocationById = createAsyncThunk('location/getById', async ({ projectId, id }) => {
    const { data } = await API.get(constructUrl(projectId, id));
    return data;
});

export const deleteLocation = createAsyncThunk('location/delete', async ({ projectId, id }) => {
    await API.delete(constructUrl(projectId, id));
    return id;
});

const locationSlice = createSlice({
    name: 'location',
    initialState: {
        locations: {},
        loading: false,
        error: null,
    },
    reducers: {
        clearLocations: () => locationSlice.getInitialState(),
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllLocations.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getAllLocations.fulfilled, (state, action) => {
                state.loading = false;
                state.locations = action.payload.reduce((acc, loc) => {
                    acc[loc.Id ?? loc.id] = loc;
                    return acc;
                }, {});
            })
            .addCase(getAllLocations.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
            .addCase(createLocation.fulfilled, () => {})
            .addCase(updateLocation.fulfilled, () => {})
            .addCase(deleteLocation.fulfilled, (state, action) => {
                delete state.locations[action.payload];
            });
    },
});

export const { clearLocations } = locationSlice.actions;
export default locationSlice.reducer;
